import React, { useEffect } from "react";
import mainLogo from "../assets/img/logo.png";
import { Link } from "react-router-dom";
import WhatsappIcon from "./WhatsappIcon";
const Header = () => {

     useEffect(() => {
    // Load the widget script
    const script = document.createElement('script');
    script.src = 'https://chat.epic-x.io/widget.js';
    script.async = true;
    
    // Optional: Add configuration
    const configScript = document.createElement('script');
    configScript.textContent = `
      window.EpicXChatConfig = {
        api:{
        shopDomain:'epic-x.io',
    }
      };
    `;
    
    document.head.appendChild(configScript);
    document.body.appendChild(script);

    return () => {
      // Cleanup on component unmount
      document.head.removeChild(configScript);
      document.body.removeChild(script);
      
      // Remove widget elements
      const widget = document.getElementById('epic-x-chat-open-chat');
      const chatbox = document.getElementById('epic-x-chat-chatbox');
      if (widget) widget.remove();
      if (chatbox) chatbox.remove();
    };
  }, []);

  return (
    <>
      {/* Topbar Start */}
      <div className="container-fluid topbar px-0 px-lg-4 bg-light py-2 d-none d-lg-block">
        <div style={{padding:'0 10px 0 10px'}}>
          <div className="row gx-0 align-items-center">
            <div className="col-lg-8 text-center text-lg-start mb-lg-0">
              <div className="d-flex flex-wrap">
                <div className="ps-0">
                  <a
                    href="mailto:techsupport@epic-x.io"
                    className="text-muted small"
                  >
                    <i className="fas fa-envelope text-primary me-2"></i>
                    techsupport@epic-x.io
                  </a>
                </div>
                <div className="ps-2">
                  <a href="tel:+918925696660" className="text-muted small">
                    <i className="fas fa-mobile-alt text-primary me-2"></i>Call
                    to Our Experts +91-8925696660
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 text-center text-lg-end">
              <div className="d-flex justify-content-end">
                <div className="d-flex border-primary pe-3">
                  <a
                    className="btn-epic-x btn-md-square text-primary me-3 rounded-circle"
                    // href="https://www.facebook.com/yourpage"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    className="btn-epic-x btn-md-square text-primary me-3 rounded-circle"
                    // href="https://www.facebook.com/yourpage"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                  <a
                    className="btn-epic-x btn-md-square text-primary me-3 rounded-circle"
                    // href="https://www.facebook.com/yourpage"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a
                    className="btn-epic-x btn-md-square text-primary me-3 rounded-circle"
                    // href="https://www.facebook.com/yourpage"
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar Start */}
      <div
        className="container-fluid nav-bar px-0 px-lg-4 py-lg-0"
        style={{
          position: "sticky",
          top: "0",
          boxShadow: "0 .125rem .25rem rgba(0, 0, 0, .075)",
        }}
      >
        <div style={{padding:'0 20px 0 20px'}}>
          <nav className="epic-x-navbar navbar-expand-lg navbar-light">
            <Link to="/" className="navbar-brand-epic-x p-0">
              <img src={mainLogo} alt="Logo" className="img-fluid" />
            </Link>
            <button
              className="navbar-toggler-epic-x"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
            >
              <span className="fa fa-bars"></span>
            </button>
            <div
              className="collapse navbar-collapse-epic-x"
              id="navbarCollapse" style={{marginLeft:'50px'}}
            >
              <div className="navbar-nav-epic-x mx-0 mx-lg-auto">
                <Link to="/About-Us" className="nav-item nav-link">
                  About
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Products
                  </Link>
                  <div className="dropdown-menu">
                    <div class="mega-column">
                      <Link to="/product/popup" className="dropdown-item">
                        Pop Up - Shopify
                      </Link>
                      <Link to="/product/chat" className="dropdown-item">
                        Chat - Shopify
                      </Link>
                      <Link to="/product/B2B" className="dropdown-item">
                        B2B - Mobile Apps
                      </Link>
                      <Link to="/product/B2C" className="dropdown-item">
                        B2C - Mobile Apps
                      </Link>
                      <Link to="/product/Email" className="dropdown-item">
                        Email Templates
                      </Link>
                      <Link to="/product/HydraTrack" className="dropdown-item">
                        Hydra Track
                      </Link>
                    </div>
                  </div>
                </div>
                <Link to="/services" className="nav-item nav-link">
                  Services
                </Link>
                <Link to="/consultant" className="nav-item nav-link">
                  Consultants
                </Link>
                <Link to="/clients" className="nav-item nav-link">
                  Clients
                </Link>
                <div className="nav-item dropdown">
                  <Link
                    to="#"
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Pricing
                  </Link>
                  <div className="dropdown-menu">
                    <div class="mega-column">
                      <Link to="/PopupPrice" className="dropdown-item">
                        Pop Up - Shopify
                      </Link>
                      <Link to="/ChatPrice" className="dropdown-item">
                        Chat - Shopify
                      </Link>
                      <Link to="/ReviewPrice" className="dropdown-item">
                        Review - Shopify
                      </Link>
                    </div>
                  </div>
                </div>
                <Link to="/contact-us" className="nav-item nav-link">
                  Contact
                </Link>
                <div className="nav-btn px-3">
                  <Link
                    to="/login"
                    className="btn-epic-x btn-outline rounded-pill py-2 px-4 ms-3"
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/Register"
                    className="btn-epic-x btn-primary rounded-pill py-2 px-4 ms-3"
                  >
                    Sign up
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
      <WhatsappIcon />
      {/* Navbar End */}
    </>
  );
};

export default Header;
